import { validateBlockListParams } from '../validateBlockListParams/validateBlockListParams';

var isBlockListDisabled = function isBlockListDisabled(options) {
  var _options$list;

  return !((_options$list = options.list) !== null && _options$list !== void 0 && _options$list.length) || !options.watchVariable;
};

var getValue = function getValue(data, name) {
  return data instanceof FormData ? data.get(name) : data[name];
};

export var isBlockedValueInParams = function isBlockedValueInParams(options, params) {
  if (isBlockListDisabled(options)) return false;
  validateBlockListParams(options.list, options.watchVariable);
  var value = getValue(params, options.watchVariable);
  if (typeof value !== 'string') return false;
  return options.list.includes(value);
};